'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import t$1 from 'tiny-warning';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { AccordionContext } from './accordion.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, o, r) {
    return o in e ? Object.defineProperty(e, o, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[o] = r, e;
}
function _object_spread(e) {
    for(var o = 1; o < arguments.length; o++){
        var r = null != arguments[o] ? arguments[o] : {}, t = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), t.forEach(function(o) {
            _define_property(e, o, r[o]);
        });
    }
    return e;
}
function ownKeys(e, o) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var t = Object.getOwnPropertySymbols(e);
        r.push.apply(r, t);
    }
    return r;
}
function _object_spread_props(e, o) {
    return o = null != o ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys(Object(o)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(o, r));
    }), e;
}
function _object_without_properties(e, o) {
    if (null == e) return {};
    var r, t, n = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(t = 0; t < s.length; t++)r = s[t], !(o.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var r, t, n = {}, s = Object.keys(e);
    for(t = 0; t < s.length; t++)r = s[t], o.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const SkinEnum = {
    STANDARD: 'standard',
    COLOR_SWATCHES: 'color-swatches'
};
let a = {
    skin: t.oneOf([
        SkinEnum.STANDARD,
        SkinEnum.COLOR_SWATCHES
    ]),
    fullBleed: t.bool,
    single: t.bool,
    purpose: t.oneOf([
        'list'
    ]),
    expandedCollapsibles: t.objectOf(t.bool.isRequired),
    onRequestExpandedChange: t.func,
    defaultExpandedCollapsibles: t.objectOf(t.bool.isRequired)
}, c = Object.keys(a), d = 'Accordion';
const Accordion = renderWithRef(d, a, (o, n)=>{
    useComponentStylesLoaded(d, SWAN_STYLE_KEY_MAP.accordion);
    let { single: a = false, expandedCollapsibles: u, onRequestExpandedChange: b, defaultExpandedCollapsibles: f, children: O, purpose: m, skin: y = 'standard', fullBleed: _ = false } = o, j = _object_without_properties(o, [
        "single",
        "expandedCollapsibles",
        "onRequestExpandedChange",
        "defaultExpandedCollapsibles",
        "children",
        "purpose",
        "skin",
        "fullBleed"
    ]), w = new Set([
        'swan-vanilla-ignore',
        'swan-accordion'
    ]);
    'color-swatches' === y && w.add(`swan-accordion-skin-${y}`), _ && w.add('swan-accordion-full-bleed'), t$1(!(void 0 !== u && void 0 !== o.single), 'Since `expandedCollapsibles` is provided, `single` will be ignored. The values in `expandedCollapsibles` will be treated as the source of truth');
    let [g, h] = useControllableValue({
        value: u || void 0,
        onChange: b || void 0,
        defaultValue: f || {},
        defaultOnChange: (e, ...o)=>{
            let [r, t] = o;
            e((e)=>_object_spread_props(_object_spread({}, a ? {} : e), {
                    [r]: t
                }));
        }
    });
    return jsx(AccordionContext.Provider, {
        value: {
            expandedCollapsibleMap: g,
            requestExpandedChange: h,
            purpose: m
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: n,
            propKeysToRemove: c,
            classNames: w,
            props: _object_spread_props(_object_spread({}, j), {
                as: 'list' === m ? o.as || o.component || 'ol' : o.as
            }),
            children: O
        })
    });
});

export { Accordion, SkinEnum };
